
  import {Component, Prop, PropSync, Vue} from 'vue-property-decorator';

  @Component
  export default class SimpleForm extends Vue {
    // Les props
    @Prop() private color!: string;
    @Prop() private title!: string;
    @Prop() private label!: string;
    @Prop({default: true}) private required!: boolean;
    @PropSync('value', {default: ''}) private theValue!: string;
    @PropSync('show') private isVisible!: boolean;

    // Les propriétés
    private isValid: boolean = false;
    private rules = [(v: string) => this.required ? v.length > 0 || 'Value is required' : true];

    // Les propriétés calculées
    // Les hooks
    // Les méthodes surveillées
    // Les méthodes d'instance
    private onData() {
      if (this.isValid) {
        this.$emit('valid');
        this.isVisible = false;
      }
    }

    // Les méthodes statiques
  }
